import { ScenariosConfig } from "./interfaces";

export const setUp508 = (onGetCurrent508WindowLayer: () => {objects: string[]}) => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.which === 9) {
            var current508Layer = onGetCurrent508WindowLayer();
            var lastObj = current508Layer.objects[current508Layer.objects.length - 1]
    
            //508 Window Constraint
            
            // if (e.shiftKey) {
            //     if (document.activeElement.id === current508Layer.objects[0]) {
            //         setFocus(lastObj);
            //         e.preventDefault();
            //     }
            // } else {
            //     if (document.activeElement.id === lastObj) {
            //         setFocus(current508Layer.objects[0]);
            //         e.preventDefault();
            //     }
            // }
        }
    });
}

export const mapDivEnterToClick = (keyUpEvt: any) => {
    if(keyUpEvt.key === 'Enter') {
        $(keyUpEvt.target as any).trigger('click');
    }
}

export const setFocus = (id: string, onDone?: (success: boolean) => void) => {
    setTimeout(() => {
        const el = document.getElementById(id);

        if(el) {
            document.getElementById(id).focus();
            if(onDone) {
                onDone(true);
            }
        } else {
            if(onDone) {
                onDone(false);
            }
        }
    }, 250);
}

export const getSaveData = (): ScenariosConfig => {
    var savedData: any = localStorage.getItem('saved-game-calm');

    if(savedData) {
        savedData = JSON.parse(savedData);
    } else {
        var newData: ScenariosConfig = {
            avatarIndx: 0,
            scenarios: [
                {
                    scenarioName: 'Level 1',
                    isUnlocked: true,
                    badges: [
                        {
                            key: 'ammonia',
                            title: 'Label Detective',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/small/badge_detective_main.png',
                            unlockedImage: './assets/images/general/badges/badge_detective_down_label.png'
                        },
                        {
                            key: 'dope',
                            title: 'Caring Leader',
                            description: '',
                            maxPoints: 3000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_caringleader_main.png',
                            unlockedImage: './assets/images/general/badges/badge_caringleader_down_large.png'
                        },
                        {
                            key: 'prescription',
                            title: 'Med Discrepancy Ace',
                            maxPoints: 1000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_medace_main.png',
                            unlockedImage: './assets/images/general/badges/badge_medace_down_large.png'
                        }
                    ],
                    questions: []
                },
                {
                    scenarioName: 'Level 2',
                    isUnlocked: false,
                    badges: [
                        {
                            key: 'tb',
                            title: 'Airborne Maestro',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 3200,
                            lockedImage: './assets/images/general/badges/small/badge_airbornmaestro_main.png',
                            unlockedImage: './assets/images/general/badges/badge_airbornmaestro_down_large.png'
                        },
                        {
                            key: 'advisor',
                            title: 'Private Explainer',
                            description: '',
                            maxPoints: 1000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_privateexplainer_main.png',
                            unlockedImage: './assets/images/general/badges/badge_privateexplainer_down_large.png'
                        }
                    ],
                    questions: []
                },
                {
                    scenarioName: 'Level 3',
                    isUnlocked: false,
                    badges: [
                        {
                            key: 'vest',
                            title: 'Equipment Master',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/small/badge_equipmaster_main.png',
                            unlockedImage: './assets/images/general/badges/badge_equipmaster_down_large.png'
                        },
                        {
                            key: 'blood',
                            title: 'Apprentice Supporter',
                            description: '',
                            maxPoints: 3000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_apprenticesupporter_main.png',
                            unlockedImage: './assets/images/general/badges/badge_apprenticesupporter_down_large.png'
                        },
                        {
                            key: 'what language',
                            title: 'Captain Linguist',
                            maxPoints: 2000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_captainlinguist_main.png',
                            unlockedImage: './assets/images/general/badges/badge_captainlinguist_down_large.png'
                        }
                    ],
                    questions: []
                },
                {
                    scenarioName: 'Level 4',
                    isUnlocked: false,
                    badges: [
                        
                        {
                            key: 'delegation',
                            title: 'Champion Delegator',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 3000,
                            lockedImage: './assets/images/general/badges/small/badge_delegator_main.png',
                            unlockedImage: './assets/images/general/badges/badge_delegator_down_large.png'
                        },
                        {
                            key: 'documentation',
                            title: 'Ready-Set-Discharge',
                            description: '',
                            maxPoints: 2000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_readysetdischarge_main.png',
                            unlockedImage: './assets/images/general/badges/badge_readysetdischarge_down_large.png'
                        },
                        {
                            key: 'trache',
                            title: 'Rapid Responder',
                            maxPoints: 3000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_rapidresponder_main.png',
                            unlockedImage: './assets/images/general/badges/badge_rapidresponder_down_large.png'
                        },
                        {
                            key: 'restaffing',
                            title: 'Assignments Guru',
                            maxPoints: 2000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_assignments_main.png',
                            unlockedImage: './assets/images/general/badges/badge_assignments_down_large.png'
                        },
                        {
                            key: 'med teacher',
                            title: 'Expert Trainer',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 3000,
                            lockedImage: './assets/images/general/badges/small/badge_experttrainer_main.png',
                            unlockedImage: './assets/images/general/badges/badge_experttrainer_down_large.png'
                        },
                        {
                            key: 'record finder',
                            title: 'Master Record Finder',
                            description: '',
                            maxPoints: 1000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_caringleader_main.png',
                            unlockedImage: './assets/images/general/badges/badge_caringleader_down_large.png'
                        }                                             
                    ],
                    questions: []
                },
                {
                    scenarioName: 'Level 5',
                    isUnlocked: false,
                    badges: [
                        {
                            key: 'ammonia',
                            title: 'Label Detective',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/small/badge_detective_main.png',
                            unlockedImage: './assets/images/general/badges/badge_detective_down_large.png'
                        },
                        {
                            key: 'dope',
                            title: 'Caring Leader',
                            description: '',
                            maxPoints: 1000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_caringleader_main.png',
                            unlockedImage: './assets/images/general/badges/badge_caringleader_down_large.png'
                        },
                        {
                            key: 'prescription',
                            title: 'Med Discrepancy Ace',
                            maxPoints: 1000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/small/badge_medace_main.png',
                            unlockedImage: './assets/images/general/badges/badge_medace_down_large.png'
                        }
                    ],
                    questions: []
                }
            ]
        };
        savedData = newData;
    }

    return savedData;
}

export const saveGame = (data: ScenariosConfig): void => {
    localStorage.setItem('saved-game-calm', JSON.stringify(data));
}

export enum ScoreType {
    Best = 0,
    Ok,
    Zero,
    Worst,
    Worst2
}

export const getOptionBorder=(scoreType: ScoreType) => {
    var color = '';

    switch(scoreType) {
        case ScoreType.Best:
            color= 'green';
            break;
        case ScoreType.Zero:
            color= 'white';
            break;
        case ScoreType.Ok:
            color= 'gold';
            break;
        case ScoreType.Worst:
            color= 'red';
            break;
        case ScoreType.Worst2:
            color= 'rgb(255, 100, 100)';
            break;
    }

    return '4px ' + color + ' solid'
}